
import React from "react";
import { useParams } from 'react-router-dom'
import { Helmet } from "react-helmet-async";
import { copy } from 'copy-anything'
import {
  Button,
  Container,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import Cookies from "universal-cookie";
const cookies = new Cookies();
function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}
class ProductCat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      package: null

    }
    //this.myRef = React.createRef()
    this.exportRef = React.createRef();
  }

  componentDidMount() {
    let { id } = this.props.params;

    window.scrollTo(0, 0);
    this.loadPackage(id)


  }

  loadPackage = (id) => {
    fetch('../API/weddingPackage.json', {
    })
      .then((response) => response.json())
      .then((responseJson) => {
        let tempData = responseJson;
        tempData.forEach((item, index) => {
          item.checked = false;
          if (item.id === parseInt(id)) {
            this.state.package = item
            this.setState({
              package: this.state.package,
            })
          }
        })



      })
      .catch(error => {
        console.log(error);
      })
  }

  render() {
    let data = this.state.package
    return (

      <>

        <DemoNavbar />
        <main ref="main">
          <section
            style={{ backgroundImage: "url(../images/inner-banner-bg.webp)", backgroundPosition: "center", backgroundSize: "cover" }}
            className="section pageTitleBG">
            <div className="row m-0">
              <div className="col-12 text-center">
                <h1 style={{ fontWeight: "500" }} className="h1 text-center text-uppercase mb-0">{this.state.package !== null ? this.state.package.name : ""}</h1>


              </div>
              <div className="col-12 mb-3 text-center"> <h1 style={{ fontWeight: "500" }} className="h2 text-center text-uppercase mb-0">

                <svg width={"20"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z" /></svg>
                <span style={{ marginLeft: "10px" }}>{this.state.package !== null ? this.state.package.price : ""}</span></h1></div>
              <div className="col-12 text-center">
                <button
                  onClick={() => {
                    if (data !== null) {
                      localStorage.setItem("porinoyMyPackage", JSON.stringify(data))
                      window.location = '/my-package'
                    }

                  }}
                  className="btn btn-danger rounded-pill text-uppercase  btn-lg">Book Now</button>
              </div>
            </div>
          </section>

          <section className="section ">
            <Container fluid>
              <div className="row">
                {data !== null &&
                  <div className="col-12 mb-5 text-center">
                    {data.description}
                  </div>
                }
                {data !== null && data.step.map((item, index) => {
                  return <div key={index} className="col-4 mb-3">
                    <div className="card shadow">
                      <div className="card-header h5 bg-white"> {item.name}
                      </div>

                      <div className="card-body ">

                        {item.thumb && item.thumb !== "" &&
                          <div className="position-relative ">
                            <div className="row align-items-center">
                              <div className="col-12"> <img className="w-100" src={item.thumb} /></div>
                              <div className="col-12"><div className=" mb-0 mt-2">{item.total} pcs </div></div>
                              {/* <div className="col text-end"><div className=" mb-0 mt-2">Price Range : {item.minPrice} - {item.maxPrice} </div></div> */}
                            </div>


                          </div>
                        }
                      </div>
                    </div>

                  </div>
                })}
                <div className="col-12 text-center mt-3"> <button
                  onClick={() => {
                    if (data !== null) {
                      localStorage.setItem("porinoyMyPackage", JSON.stringify(data))
                      window.location = '/my-package'
                    }

                  }}
                  className="btn btn-danger rounded-pill text-uppercase  btn-lg">Book Now</button></div>

              </div>
            </Container>
          </section>
        </main>
        <SimpleFooter />

      </>
    );
  }
}
export default withParams(ProductCat);
